import React from "react";
import { FormattedMessage } from "react-intl";
import Box from "@redbubble/design-system/react/Box";
import Label from "@redbubble/design-system/react/Label";
import TabList, { Tab } from "../../../../Tabs";
import { localizedPath } from "../../../../../lib/routing";

import messages from "../../messages";

const TabNav = ({
  commentsCount,
  currentPath,
  locale,
  productsCount,
  workId,
}) => {
  return (
    <Box>
      <TabList position="center">
        <Tab
          position="center"
          to={{
            pathname: localizedPath(locale, `/shop/ap/${workId}`),
          }}
          active={currentPath === `/shop/ap/${workId}`}
        >
          <FormattedMessage
            {...messages.shopProducts}
            values={{ productsCount }}
          />
        </Tab>

        <Tab
          position="center"
          to={{
            pathname: localizedPath(locale, `/shop/ap/${workId}/comments`),
          }}
          active={currentPath === `/shop/ap/${workId}/comments`}
          rel="nofollow"
        >
          <FormattedMessage {...messages.viewComments} />
          {commentsCount > 0 && (
            <Box marginLeft="xs">
              <Label subtle>{commentsCount}</Label>
            </Box>
          )}
        </Tab>
      </TabList>
    </Box>
  );
};

export default TabNav;
